module.exports = __webpack_public_path__ + "static/media/story_alive_m.6809fc21.png";